"use client";

import { MaybeBrandReviewTile } from "@faire/deprecated-retailer-visitor-shared/components/MaybeBrandReviewTile/MaybeBrandReviewTile";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import { useStrictLocalization } from "@faire/web/common/localization/localize";
import { formatMoney, RoundingStrategy } from "@faire/web/common/money";
import { Row } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";

interface Props {
  minimumOrderAmount?: IFaireMoney;
  avgBrandReviewRating?: string;
  isLoggedInRetailer?: boolean;
}

export const BrandMinimum: React.FC<Props> = (props) => {
  const { strictLocalize } = useStrictLocalization();
  const { minimumOrderAmount, avgBrandReviewRating } = props;

  const getMinimumText = () => {
    if (minimumOrderAmount) {
      return strictLocalize(
        {
          id: "hvX3CB",
          defaultMessage: "{minMoney} min",
          description: {
            text: "minMoney is the minimum a retailer must order to be able to order from this brand",
            img: "https://cdn.faire.com/fastly/49c2b53d16ec4a32fc5a7de143dc0d994492dfd02dfed6be70d31d4955809ed3.png",
          },
        },
        {
          minMoney: formatMoney({
            money: minimumOrderAmount,
            omitCentsIfZero: true,
            roundingStrategy: RoundingStrategy.DROP_CENTS_ROUND_UP,
          }),
        }
      );
    }

    return null;
  };

  if (!props.isLoggedInRetailer) {
    return null;
  }

  return (
    <Row>
      <MaybeBrandReviewTile rating={avgBrandReviewRating} />
      <Typography>{getMinimumText()}</Typography>
    </Row>
  );
};
